export function useCtx(call, el) {
    const { $gsap: gsap } = useNuxtApp();
    return gsap.context(call, el);
}